module.exports = __webpack_public_path__ + "static/strategic-advisory-banner-overlay-c0330c1482f2c0be3e42a5ed364b86a7.png";